import { render, staticRenderFns } from "./AccountRoleAssignDialog.vue?vue&type=template&id=351fa352&scoped=true&"
import script from "./AccountRoleAssignDialog.vue?vue&type=script&lang=js&"
export * from "./AccountRoleAssignDialog.vue?vue&type=script&lang=js&"
import style0 from "./AccountRoleAssignDialog.vue?vue&type=style&index=0&id=351fa352&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351fa352",
  null
  
)

export default component.exports